const version = "2024.10.1";
export {
  version
};
//# sourceMappingURL=package.json.mjs.map
